function isHtmlResponse(data, contentType = "") {
  if (typeof data !== "string") {
    return false;
  }

  const trimmed = data.trim().toLowerCase();
  return (
    contentType.includes("text/html") ||
    trimmed.startsWith("<!doctype") ||
    trimmed.startsWith("<html")
  );
}

function firstValidationMessage(data) {
  if (!data?.errors || typeof data.errors !== "object") {
    return null;
  }

  const field = Object.keys(data.errors)[0];
  const message = data.errors[field]?.[0];
  return typeof message === "string" ? message : null;
}

export function getLoginErrorMessage(error) {
  const response = error?.response;

  if (!response) {
    if (error?.code === "ECONNABORTED") {
      return "The server took too long to respond. Please try again.";
    }

    return "Cannot reach the server. Check your connection and try again.";
  }

  const { status, data, headers = {} } = response;
  const contentType = headers["content-type"] || "";

  if (isHtmlResponse(data, contentType)) {
    if (status === 404) {
      return "Cannot reach the API (404). The server may be misconfigured — contact your administrator.";
    }

    return "Unexpected server response. The API may be misconfigured — contact your administrator.";
  }

  const validationMessage = firstValidationMessage(data);
  if (validationMessage) {
    return validationMessage;
  }

  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message;
  }

  if (status === 401) {
    return "Invalid email or password.";
  }

  if (status === 403) {
    return "You do not have permission to sign in.";
  }

  if (status === 404) {
    return "Cannot reach the API (404). The server may be misconfigured — contact your administrator.";
  }

  if (status >= 500) {
    return "Server error. Please try again later or contact your administrator.";
  }

  return "Sign in failed. Please try again.";
}
